import { Outlet } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import { Footer } from "@/components/ui/footer";
import { Toaster } from "sonner";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import { ThemeProvider } from "@/context/ThemeContext";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

export default function RootLayout() {
  const navigate = useNavigate();

  return (
    <ClerkProvider navigate={navigate} publishableKey={PUBLISHABLE_KEY}>
      <ThemeProvider>
      <SubscriptionProvider>
        <main className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <Outlet />
          </div>
          <Footer />
        </main>
        <Toaster position="bottom-right" richColors />
      </SubscriptionProvider>
      </ThemeProvider>
    </ClerkProvider>
  );
}
